import moment from 'moment';
import { Tag } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import React from 'react';

export const getPlusThreeNumbersUntilTotal = (start, total, span) => {
  const result = [];
  for (let i = start; i <= total; i += span) {
    result.push(i);
  }
  return result;
};

export const getColumnSearchProps = (dataIndex, searchInput, searchText, setSearchText) => ({
  filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    <div style={{ padding: 8 }}>
      <input
        ref={searchInput}
        placeholder={`Search ${dataIndex}`}
        value={selectedKeys[0]}
        onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
        onKeyDown={(e) => e.key === 'Enter' && handleSearch(selectedKeys, confirm, setSearchText)}
        style={{ width: 188, marginBottom: 8, display: 'block' }}
      />
      <button onClick={() => handleSearch(selectedKeys, confirm, setSearchText)}>Search</button>
      <button onClick={() => handleReset(clearFilters, confirm, setSearchText)}>Reset</button>
    </div>
  ),
  filterIcon: (filtered) => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
  onFilter: (value, record) =>
    record?.[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()),
  render: (text) =>
    <Highlighter
      highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
      searchWords={[searchText]}
      autoEscape
      textToHighlight={text ? text.toString() : ''}
    />
});

export const handleSearch = (selectedKeys, confirm, setSearchText) => {
  confirm();
  setSearchText(selectedKeys[0]);
};

export const handleReset = (clearFilters, confirm, setSearchText) => {
  clearFilters();
  handleSearch([], confirm, setSearchText);
};

export const generateColumn = (column, tableConfig, searchInput, searchText, setSearchText) => {
  const { textAlign = 'center', fontWeight } = tableConfig;

  const baseCol = {
    ...column,
    ...(column.colSpanProp?.show && {
      onCell: (_, index) => {
        const rows = getPlusThreeNumbersUntilTotal(0, column.colSpanProp.totalRows, column.colSpanProp.span);
        return { rowSpan: rows.includes(index) ? column.colSpanProp.span : 0 };
      }
    }),
    onFilter: (value, record) => record[column.key]?.indexOf(value) === 0,
    ...(column.rowFilter && getColumnSearchProps(column.key, searchInput, searchText, setSearchText)),
  };

  if (column.key === 'Status') {
    return {
      ...baseCol,
      render: (text, record) => ({
        children: (
          <div style={{ textAlign }}>
            {record?.Color ? <Tag color={record.Color}>{text}</Tag> : text}
          </div>
        )
      })
    };
  }

  if (column.isUTC) {
    return {
      ...baseCol,
      render: (text) => ({
        children: text !== 'Total' ? moment.utc(text).local().format('YYYY-MM-DD HH:mm:ss') : text
      })
    };
  }

  return {
    ...baseCol,
    render: (text, record) => ({
      props: {
        style: { background: record?.color || column.background }
      },
      children: <div style={{ textAlign, fontWeight }}>{text !== 'null' ? text : ''}</div>
    })
  };
};
